import cn from 'classnames'

import { skeletonStyle } from './index.css'

type Props = {
  className?: string
  height?: number
  width?: number
}

export const Skeleton: React.FC<Props> = ({ className, height, width }) => (
  <div className={cn(skeletonStyle, className)} style={{ height, width }} />
)
